/* Configurateur de parasols Glatz — v1.7b (22.10.2026)
 * v1.7b : toile indisponible (variante bloquée à 0 en stock, ou absente dans cette taille) = vraie couleur, barrée,
 *   mention « Indisponible », non sélectionnable (un clic montre seulement le zoom de la toile).
 * v1.7 : ouverture depuis une fiche parasol (snippets/cfgp-bouton.liquid) :
 *   ?modele=<clé>&variant=<id>&bride=1 → modèle imposé (sans « Changer de parasol »), variante de la fiche reprise.
 * v1.6 : montable hors Shopify (formulaire offres.jardin-confort.ch) : window.CFGP.mount(el, opts)
 *   opts = { shop, models, cfg, data, base, get(path) → Promise(texte|null), liste(payload) → Promise({ok, msg}),
 *            copy(texte), scroll(y, mode) }. Sur la boutique : démarrage automatique sur #cfgp, sans options.
 * Les fixations par modèle sont construites ici (buildModel) à partir de la liste des SKU Glatz de chaque modèle.
 * Section : sections/configurateur-parasol.liquid · Données : assets/configurateur-parasol-data.js (window.CFGP_DATA)
 * Produits lus par SKU via /products/<handle>?view=cfgparasol (templates/product.cfgparasol.liquid).
 * Règle : un SKU trouvé actif dans la boutique va au panier ; sinon il part dans la liste « sur offre »
 * (prix catalogue Glatz TTC) — jamais les deux.
 * IMAGES DES CARTES FIXATION : balise [configurateur <variante> / <variante accessoire>] dans le texte alt
 * de l'image de montage complet de l'article principal (voir kitImg et product.cfgparasol.liquid).
 * VIGNETTES DE TOILE : table TOILES (export Supabase matieres) — à régénérer si nouvelles toiles.
 */
(function () {
  'use strict';
  function start(root, O) {
  O = O || {};
  if (!root || root.__cfgp) return;
  root.__cfgp = true;
  var EMB = !!O.get; // monté dans le formulaire (iframe isolé) : réseau, liens et défilement passent par les options
  var BASE = (O.base || '').replace(/\/$/, '');
  if (EMB) root.classList.add('cfgp--embed');

  /* ---------- utilitaires ---------- */
  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function unit(s) { // unités sans espace, comme dans la boutique : 120kg, 480mm, 40x40cm, Ø31mm
    return String(s == null ? '' : s).replace(/Ø\s+(?=\d)/g, 'Ø').replace(/(\d)\s*[×x]\s*(?=\d)/g, '$1x').replace(/(\d)\s+(kg|cm|mm)\b/g, '$1$2');
  }
  function esc(s) { return unit(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJSON(id) { try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return {}; } }
  var SHOP = O.shop || readJSON('cfgp-shop');
  var MODINFO = O.models || readJSON('cfgp-models');
  function xget(url) { // texte de la page, ou null
    if (EMB) return Promise.resolve(O.get(url)).catch(function () { return null; });
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : null; });
  }
  var QS = EMB ? new URLSearchParams('') : new URLSearchParams(location.search);
  var QVID = /^\d{5,20}$/.test(QS.get('variant') || '') ? QS.get('variant') : ''; // variante choisie sur la fiche
  var LOCK = null;                                                       // modèle imposé (bride=1)
  var RT = root.dataset.root || '/';
  if (RT.slice(-1) !== '/') RT += '/';

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    var fmt = SHOP.money || 'CHF {{amount}}';
    var v = Math.round(cents) / 100;
    function grp(n, dec, th, ds) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return grp(v, 0, ',', '.');
        case 'amount_with_comma_separator': return grp(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return grp(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return grp(v, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return grp(v, 0, ' ', '.');
        case 'amount_with_space_separator': return grp(v, 2, ' ', ',');
        default: return grp(v, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function pvi(chf) { return chf == null ? null : Math.round(chf * 100); }

  /* clé de taille normalisée (même règle que le générateur) : d400 / 400x300 (+|8 pour les baleines) */
  function sizeKey(name, withBal) {
    var s = String(name).toLowerCase().replace(/×/g, 'x');
    var bal = (s.match(/(\d+)\s*baleines/) || [])[1];
    s = s.replace(/\d+\s*baleines/, '').replace(/cm/g, '').replace(/\s+/g, '');
    var m = s.match(/^(ø|⌀|o|d)?(\d+)(?:x(\d+))?/);
    if (!m) return null;
    var key;
    if (m[1] && !m[3]) key = 'd' + m[2];
    else if (m[3]) { var a = +m[2], b = +m[3]; key = Math.max(a, b) + 'x' + Math.min(a, b); }
    else key = 'd' + m[2];
    return withBal && bal ? key + '|' + bal : key;
  }
  function keyLabel(k) {
    var b = k.split('|');
    var s = b[0].charAt(0) === 'd' ? 'Ø' + b[0].slice(1) + 'cm' : b[0] + 'cm';
    return b[1] ? s + ' (' + b[1] + ' baleines)' : s;
  }
  function keySpan(k) { // plus grande dimension en cm
    var b = k.split('|')[0];
    return b.charAt(0) === 'd' ? +b.slice(1) : +b.split('x')[0];
  }
  function keySides(k) { var b = k.split('|')[0]; return b.charAt(0) === 'd' ? [] : b.split('x').map(Number); }

  /* ---------- données ---------- */
  var D = null;
  var PCACHE = {};   // handle|ov -> Promise(json|null)
  var SKU = {};      // sku -> Promise({sku, vid, p, a, sk, img, t, pt, u} | null)

  function getProd(handle, ov, vid) {
    var key = handle + '|' + (ov || '') + '|' + (vid || '');
    if (PCACHE[key]) return PCACHE[key];
    var url = RT + 'products/' + encodeURIComponent(handle) + '?view=cfgparasol' + (ov ? '&option_values=' + ov : '') + (vid ? '&variant=' + vid : '');
    PCACHE[key] = xget(url)
      .then(function (t) { if (!t) return null; try { return JSON.parse(t); } catch (e) { return null; } })
      .catch(function () { return null; });
    return PCACHE[key];
  }
  function findHandle(sku) {
    var u = RT + 'search/suggest.json?q=' + encodeURIComponent(sku) +
      '&resources[type]=product&resources[limit]=4&resources[options][fields]=variants.sku';
    return xget(u).then(function (t) { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } })
      .then(function (j) {
        var ps = j && j.resources && j.resources.results && j.resources.results.products || [];
        return ps.map(function (p) { return p.handle; });
      }).catch(function () { return []; });
  }
  function fromProd(p, sku) {
    if (!p || !p.vs) return null;
    for (var i = 0; i < p.vs.length; i++) {
      var v = p.vs[i];
      if (String(v.sku).replace(/\s/g, '') === sku) {
        return { sku: sku, vid: v.id, p: v.p, a: v.a, sk: v.sk, img: v.img || p.img, vt: v.t, cfgi: p.cfgi || [], t: p.t + (v.t && v.t !== 'Default Title' ? ' — ' + v.t : ''), u: p.u };
      }
    }
    return null;
  }
  function resolve(sku) {
    if (!sku || /X/.test(sku)) return Promise.resolve(null);
    if (SKU[sku]) return SKU[sku];
    var h = D.h[sku];
    SKU[sku] = (h ? getProd(h).then(function (p) { return fromProd(p, sku); }) : Promise.resolve(null))
      .then(function (r) {
        if (r) return r;
        return findHandle(sku).then(function (hs) {
          return hs.reduce(function (pr, hh) {
            return pr.then(function (found) { return found || getProd(hh).then(function (p) { return fromProd(p, sku); }); });
          }, Promise.resolve(null));
        });
      });
    return SKU[sku];
  }
  var R = {}; // résolus (synchrones) : sku -> objet | null
  function preload(skus) {
    return Promise.all(skus.filter(function (s, i) { return s && skus.indexOf(s) === i && !(s in R); })
      .map(function (s) { return resolve(s).then(function (r) { R[s] = r; }); }));
  }
  function cat(sku) { var c = D && D.cat[sku]; return c ? { n: c[0], p: c[1] } : { n: sku, p: null }; }
  /* ---------- construction des fixations (règles Glatz, mêmes règles que le générateur Python) ---------- */
  var PFX = '35001';
  var TZ = ['200135', '201010', '201100', '201210', '201282', '201300', '201400', '201500', '201710', '201610'];
  var TM4 = ['200035', '200082', '200235', '227080', '227300', '22730019', '227040', '22704019'];
  var CM8 = ['225040', '22504019'], CM16 = ['225045', '22504519'];
  var RPX = ['206001', '206082', '206011', '206050', '206040', '206020', '206030'];
  var RBT = ['206210', '201930', '201920', '201830', '201820'], RST = ['205100'];
  var SIB = [['113810', '113820', '113830'], ['113910', '113920', '113940'], ['113310', '113320', '114340']]; // mêmes articles, autres couleurs (gris soie)
  var PIEDS = ['220940', '220960', '220950', '220970'];
  var LAB = { // libellés courts des variantes
    '200135': 'galvanisé', '201010': 'galvanisé', '201100': 'inox', '201210': 'galvanisé', '201282': 'galvanisé, laqué anthracite', '201300': 'inox',
    '201400': 'galvanisé', '201500': 'inox', '201710': 'galvanisé', '201610': 'galvanisé', '200035': 'galvanisé', '200082': 'galvanisé, laqué anthracite',
    '200235': 'galvanisé', '227080': 'galvanisé', '227300': 'galvanisé', '22730019': 'anthracite', '227040': 'galvanisé', '22704019': 'anthracite',
    '225040': 'galvanisé', '22504019': 'anthracite', '225045': 'galvanisé', '22504519': 'anthracite', '206001': 'galvanisé', '206082': 'galvanisé, laqué anthracite',
    '206011': 'inox', '206050': 'galvanisé, alu naturel', '206040': 'galvanisé, anthracite', '206020': 'inox, alu naturel', '206030': 'inox, anthracite',
    '206210': 'galvanisé', '201930': 'anthracite', '201920': 'gris soie', '201830': 'anthracite', '201820': 'gris soie', '205100': 'galvanisé',
    '220940': 'fixe, gris graphite', '220960': 'fixe, anthracite', '220950': 'pivotant, gris graphite', '220970': 'pivotant, anthracite',
    '109487': 'galvanisé', '109486': 'inox', '101001': 'galvanisé', '101000': 'inox', '100500': 'galvanisé',
    '113310': 'blanc gris', '113320': 'anthracite', '114340': 'gris soie', '113710': 'blanc gris', '113720': 'anthracite', '113910': 'blanc gris',
    '113920': 'anthracite', '113940': 'gris soie', '113610': 'blanc', '113620': 'anthracite', '113810': 'blanc', '113820': 'anthracite', '113830': 'gris soie',
    '100617': 'aspect alu anodisé', '100630': 'anthracite', '100717': 'aspect alu anodisé', '100730': 'anthracite', '227417': 'aspect alu', '227430': 'anthracite',
    '227517': 'aspect alu', '227530': 'anthracite', '226908': 'béton', '226909': 'béton + aspect granit', '226907': 'béton', '226906': 'béton + aspect granit',
    '109495': 'brillant', '109438': 'mat', '207001': 'galvanisé', '207011': 'inox'
  };
  var DIA = { // diamètre du mât accepté par les tubes (repris des titres Shopify), affiché devant la finition
    '200135': 'Ø25-33mm', '201010': 'Ø35/38-39mm', '201100': 'Ø35/38-39mm', '201210': 'Ø48/55mm', '201282': 'Ø48/55mm', '201300': 'Ø48/55mm',
    '201400': 'P+', '201500': 'P+', '201710': 'interne Ø30/25mm', '201610': 'interne Ø40/37mm',
    '200035': 'Ø48/55mm', '200082': 'Ø48/55mm', '200235': 'P+',
    '206001': 'Ø48/55mm', '206082': 'Ø48/55mm', '206011': 'Ø48/55mm', '206050': 'P+', '206040': 'P+', '206020': 'P+', '206030': 'P+',
    '206210': 'Ø35/38-39mm', '205100': 'Ø25-33mm'
  };
  var ZW = [['111016', 30, 'Socle béton clair 30 kg'], ['111116', 40, 'Socle béton clair 40 kg'], ['109529', 40, 'Socle béton gris 40 kg'],
    ['111216', 55, 'Socle béton clair 55 kg'], ['111316', 70, 'Socle béton clair 70 kg'], ['111416', 90, 'Socle béton clair 90 kg'],
    ['109480', 30, 'Demi-socle granit 30 kg'], ['109432', 40, 'Socle granit mat 40 kg'], ['109467', 40, 'Socle granit 40 kg'],
    ['109447', 55, 'Socle granit brillant 55 kg'], ['109434', 55, 'Socle granit mat 55 kg'], ['109436', 90, 'Socle granit mat 90 kg'],
    ['100810', 40, 'Socle acier 40 kg'], ['100910', 55, 'Socle acier 55 kg'],
    ['109465', 40, 'Socle granit 40 kg à roulettes et poignée'], ['109445', 55, 'Socle granit 55 kg à roulettes et poignée'],
    ['113200', 55, 'Socle à roulettes béton 55 kg'], ['113400', 90, 'Socle à roulettes béton 90 kg']];
  var ANCH = [ // ancrages fixes : suffixe, type, libellé, famille de tube, note
    ['205105', 'sol', 'Douille à bétonner ST', 'ST'], ['206100', 'sol', 'Douille à bétonner BT', 'BT'],
    ['226510', 'sol', 'Douille à bétonner M4', 'M4'], ['226000', 'sol', 'Douille à bétonner M8', 'M8'], ['226001', 'sol', 'Douille à bétonner M16', 'M16'],
    ['226921', 'dalle', 'Plaque de montage M4/M8 (à visser sur dalle béton)', 'M4'],
    ['226932', 'dalle', 'Plaque de montage M4 spéciale (hauteur 50–149 mm)', 'M4'], ['226930', 'dalle', 'Plaque de montage M4 spéciale (hauteur 150–350 mm)', 'M4'],
    ['222510', 'dalle', 'Plaque de montage M4 hautes isolations (sur mesure)', 'M4', 'Fabriquée sur mesure.'],
    ['229707', 'dalle', 'Plaque de montage M8 spéciale (hauteur 50–149 mm)', 'M8'], ['229705', 'dalle', 'Plaque de montage M8 spéciale (hauteur 150–350 mm)', 'M8'],
    ['223510', 'dalle', 'Plaque de montage M8 hautes isolations (sur mesure)', 'M8', 'Fabriquée sur mesure.'],
    ['229701', 'dalle', 'Plaque de montage M16', 'M16'], ['229712', 'dalle', 'Plaque de montage M16 spéciale (hauteur 50–149 mm)', 'M16'],
    ['229710', 'dalle', 'Plaque de montage M16 spéciale (hauteur 150–350 mm)', 'M16'],
    ['224510', 'dalle', 'Plaque de montage M16 hautes isolations (sur mesure)', 'M16', 'Fabriquée sur mesure.'],
    ['205000', 'mur', 'Console murale Z 180 mm', 'Z'], ['229405', 'mur', 'Console murale M4, portée 480 mm', 'M4'],
    ['229410', 'mur', 'Console murale M4, portée 100 mm', 'M4'],
    ['205400', 'gazon', 'Pointe à gazon Z', 'Z', 'Pour pelouse ou sol meuble.'],
    ['252005', 'table', 'Bride U pour plateau de table (Ø 31–40 mm)', null, 'Uniquement sur un plateau de table horizontal et plat.']];

  function buildModel(mk, r) {
    var ss = {};
    r.ss.split(' ').forEach(function (s) { ss[PFX + s] = 1; });
    SIB.forEach(function (f) { if (f.some(function (s) { return ss[PFX + s]; })) f.forEach(function (s) { ss[PFX + s] = 1; }); }); // couleur d'un même article = toutes ses couleurs
    function has(s) { return !!ss[PFX + s]; }
    function fam(list) { return list.filter(has); }
    function o(list, lab) { return fam(list).map(function (s) { return { s: PFX + s, l: lab === false ? '' : [DIA[s], LAB[s]].filter(Boolean).join(', ') }; }); }
    function slot(l, list) { var x = o(list); return x.length ? { l: l, o: x } : null; }
    function tubes(f) {
      if (!f) return [];
      if (f === 'Z') return [slot('Tube de fixation Z', TZ)];
      if (f === 'M4') {
        if (mk === 'fortano') return [slot('Pied M4 Fortano', PIEDS)];
        if (mk === 'style' || mk === 'noblesse') return [slot('Tube de fixation M4 à profil', TM4)];
        return [slot('Tube de fixation M4', TM4)];
      }
      if (f === 'M8') return [slot('Charnière de montage M8', CM8)];
      if (f === 'M16') return [slot('Charnière de montage M16', CM16)];
      if (f === 'ST') return [slot('Tube de raccord ST', RST)];
      if (f === 'BT') return [slot('Tube de raccord BT', RBT)];
      if (f === 'PX') return [slot('Tube de raccord PX', RPX)];
      return [];
    }
    function clean(l) { return l.filter(Boolean); }
    function combo() { // tube M4 à profil ou charnière M8 (Palazzo Style / Noblesse)
      var x = slot('Tube de fixation M4 à profil ou charnière M8', TM4.concat(CM8));
      if (x) x.o.forEach(function (y) { y.l = (CM8.indexOf(y.s.slice(5)) >= 0 ? 'charnière M8, ' : 'tube M4, ') + y.l; });
      return x;
    }
    var K = [];
    function add(k) {
      if (k.req) { k.req = clean(k.req); if (!k.req.length) delete k.req; }
      if (k.opt) { k.opt = k.opt.filter(function (x) { return x && x.o.length; }); if (!k.opt.length) delete k.opt; }
      if (k.excl && !(k.opt && k.opt.length > 1)) delete k.excl; // il faut les deux options (cache ET roues)
      K.push(k);
    }
    var styleNob = mk === 'style' || mk === 'noblesse';
    var XCACHE = { a: 0, b: 1, n: 'Le jeu de roues ne convient pas avec un cache-socle (les roues se coincent dans le cache) : choisir l’un ou l’autre.' }; // note 6 liste de prix Glatz
    ANCH.forEach(function (a) {
      if (!has(a[0])) return;
      var req = tubes(a[3]);
      if (a[0] === '226921' && styleNob) req = [combo()];
      var k = { id: PFX + a[0], t: a[1], l: a[2], main: [{ s: PFX + a[0], l: '' }], req: req };
      if (a[4]) k.note = a[4];
      add(k);
    });
    if (has('207001') || has('207011')) {
      add({ id: 'px', t: 'sol', l: 'Douille à bétonner PX', main: o(['207001', '207011']),
        req: mk === 'fortello' ? [{ l: 'Adaptateur PX à M4', o: [{ s: PFX + '221800', l: '' }] }, slot('Tube de fixation M4', TM4)] : tubes('PX') });
    }
    ZW.forEach(function (z) {
      var s = z[0]; if (!has(s)) return;
      var req = tubes('Z'), opt = [];
      if (['109432', '109467', '109447', '109434', '109436'].indexOf(s) >= 0) opt = [slot('Jeu de roues (sols lisses sans joints)', ['109487', '109486'])];
      if (s === '100810' || s === '100910') opt = [slot('Jeu de roues (sols lisses sans joints)', ['101001', '101000'])];
      if (s === '113200') req = req.concat([slot('Plaque décorative', ['113310', '113320', '114340'])]);
      var k = { id: PFX + s, t: ['109465', '109445', '113200', '113400'].indexOf(s) >= 0 ? 'roul' : 'socle', l: z[2], kg: z[1], main: [{ s: PFX + s, l: '' }], req: req, opt: opt };
      if (s === '100810' || s === '100910') k.note = 'Socle plus bas : le parasol est plus bas de 5 cm.';
      add(k);
    });
    if (has('108235')) add({ id: PFX + '108235', t: 'socle', l: 'Cadre de socle M4 120 kg + 8 dalles', kg: 120, main: [{ s: PFX + '108235', l: '' }],
      req: tubes('M4').concat([slot('Dalles (8 pièces 40 × 40 cm)', ['226908', '226909'])]),
      opt: [slot('Cache-socle', ['100617', '100630']), slot('Jeu de roues (sols lisses sans joints)', ['100500'])], excl: XCACHE });
    if (has('108335')) add({ id: PFX + '108335', t: 'socle', l: 'Cadre de socle M4 180 kg + 12 dalles', kg: 180, main: [{ s: PFX + '108335', l: '' }],
      req: tubes('M4').concat([slot('Dalles (12 pièces 40 × 40 cm)', ['226907', '226906'])]),
      opt: [slot('Cache-socle', ['100717', '100730']), slot('Jeu de roues (sols lisses sans joints)', ['100500'])], excl: XCACHE });
    if (has('109495') || has('109438')) add({ id: 'granitm4', t: 'socle', l: 'Socle granit M4 120 kg', kg: 120, main: o(['109495', '109438']),
      req: tubes('M4'), opt: [slot('Jeu de roues (sols lisses sans joints)', ['109487', '109486'])] });
    if (has('113610') || has('113620')) {
      var lest = [{ s: PFX + '110500', l: 'kit de poids béton (env. 90 kg)', kg: 120 }];
      if (has('110550')) lest.push({ s: PFX + '110550', l: 'récipients à remplir (90 kg max.)', kg: 90 });
      add({ id: 'roulm4120', t: 'roul', l: 'Socle à roulettes M4 120 kg', kg: 120, main: o(['113610', '113620']),
        req: tubes('M4').concat([{ l: 'Lest', o: lest }, slot('Plaque décorative', ['113710', '113720'])]) });
    }
    if (has('113810') || has('113820') || has('113830')) add({ id: 'roulm4180', t: 'roul', l: 'Socle à roulettes M4 180 kg', kg: 180, main: o(['113810', '113820', '113830']),
      req: tubes('M4').concat([{ l: 'Kit de poids (env. 150 kg)', o: [{ s: PFX + '110800', l: '' }] }, slot('Plaque décorative', ['113910', '113920', '113940'])]) });
    if (has('226945')) {
      var tub = mk === 'royal' ? tubes('M16') : (styleNob ? [combo()] : tubes('M4'));
      [[240, '226950', ['227417', '227430']], [310, '226952', ['227517', '227530']], [430, '226948', []], [570, '226954', []], [690, '226956', []]].forEach(function (x) {
        if (!has(x[1])) return;
        add({ id: 'pro' + x[0], t: 'socle', l: 'Socle pro ' + x[0] + ' kg (cadre + éléments béton)', kg: x[0], main: [{ s: PFX + '226945', l: '' }],
          req: tub.concat([{ l: 'Éléments béton', o: [{ s: PFX + x[1], l: '' }] }]), opt: x[2].length ? [slot('Cache-socle', x[2])] : [] });
      });
    }
    var sz = {};
    r.sz.forEach(function (z) { sz[z[0]] = { kg: z[1], f: z[2], v: z[3] }; });
    var CATN = { L: 'Éclairage LED sans fil', B: 'Batterie de rechange', C: 'Chauffage radiant', T: 'Télécommande supplémentaire', S: 'Système de sanglage' };
    var a = r.a.filter(function (x) { return !DROPACC[x[0]]; }).map(function (x) {
      var y = { s: PFX + x[0], c: CATN[x[1]] };
      if (x[2]) y.z = x[2].split(' ');
      if (x[1] === 'C') { y.q = 4; y['with'] = PFX + '570700'; }
      return y;
    });
    var off = r.pz.map(function (x) {
      return { s: PFX + x[0], pvi: x[1], n: /^(LED blanc|Motorisation)/.test(x[2]) ? x[2] : 'Commande Pz200 pour ' + x[2] };
    }).concat(r.par.map(function (x) { return { s: PFX + x[0], pvi: x[1], n: 'Paroi latérale ' + x[2] }; }));
    return {
      n: r.n, h: r.h, g: r.g, pro: r.pro, offre: r.offre, sz: sz, k: K,
      hs: r.hs.map(function (x) { var y = { s: PFX + x[0] }; if (x[1]) y.z = x[1].split(' '); return y; }),
      a: a, o: off
    };
  }
  function expand(j) {
    var out = { v: j.v, models: {}, cat: {}, h: {} };
    Object.keys(j.m).forEach(function (mk) { if (HIDE[mk]) return; out.models[mk] = buildModel(mk, j.m[mk]); out.models[mk].n = niceName(mk, out.models[mk]); });
    Object.keys(j.cat).forEach(function (s) { out.cat[PFX + s] = j.cat[s]; });
    Object.keys(j.h).forEach(function (s) { var h = j.h[s]; out.h[PFX + s] = h.charAt(0) === '!' ? h.slice(1) : 'glatz-' + h; });
    return out;
  }
  function inShop(sku) { var r = R[sku]; return !!(r && r.a); }
  function unitPrice(sku) { var r = R[sku]; if (r && r.a) return r.p; var c = cat(sku); return pvi(c.p); }
  function label(sku) { var r = R[sku]; return r ? r.t : cat(sku).n; }

  /* ---------- état ---------- */
  var st = {
    grp: null, sh: null, bk: -1, mk: null, prod: null, ovSel: [], key: null,
    kit: null, kitReq: {}, kitOpt: {}, none: false,
    hs: {}, acc: {}, pz: '', par: {}
  };
  var TYPES = [
    { g: 'centre', l: 'Mât central', d: 'Le classique : mât au centre (aluminium ou bois), idéal au-dessus d’une table.' },
    { g: 'deporte', l: 'Mât déporté', d: 'Mât sur le côté : la surface sous la toile reste libre, idéal pour un salon.' },
    { g: 'bois', l: 'Aspect bois', d: 'Mât central en bois ou imitation bois.' },
    { g: 'pro', l: 'Grand parasol professionnel', d: 'Grandes surfaces, terrasses, fortes rafales.' },
    { g: 'all', l: 'Je connais mon modèle', d: 'Voir tous les parasols Glatz.' }
  ];
  var ICO = { // pictos des types (traits, couleur du texte)
    centre: '<path d="M8 19 Q32 3 56 19 Z"/><path d="M32 19 V42 M24 42 H40"/>',
    deporte: '<path d="M10 42 V6 Q26 3 36 9"/><path d="M36 9 V12"/><path d="M12 26 Q36 7 60 26 Z"/><path d="M4 42 H16"/>',
    bois: '<path d="M8 19 Q32 3 56 19 Z"/><rect x="29.5" y="19" width="5" height="23" rx="1"/><path d="M32 23 v4 M32 31 v5"/><path d="M22 42 H42"/>',
    pro: '<path d="M2 21 Q32 2 62 21 Z"/><path d="M27 9 Q32 6 37 9"/><path d="M32 21 V40"/><rect x="21" y="40" width="22" height="4" rx="1"/>',
    all: '<circle cx="27" cy="21" r="11"/><path d="M35 29 L46 40"/>'
  };
  function ico(g) { return '<svg class="cfgp-ico" viewBox="0 0 64 48" aria-hidden="true">' + (ICO[g] || '') + '</svg>'; }
  var SHAPES = [ // formes et tailles comme le configurateur Glatz (plus grand côté, cm)
    { s: 'rond', l: 'Rond', b: [[0, 300, '200–300'], [301, 400, '301–400'], [401, 9999, '401–800']] },
    { s: 'carre', l: 'Carré', b: [[0, 250, '200×200 – 250×250'], [251, 350, '251×251 – 350×350'], [351, 9999, '351×351 – 700×700']] },
    { s: 'rect', l: 'Rectangulaire', b: [[0, 300, '200×150 – 300×230'], [301, 600, '301×200 – 600×500'], [601, 9999, '601×400 – 800×700']] }
  ];
  function keyShape(k) { var b = k.split('|')[0]; if (b.charAt(0) === 'd') return 'rond'; var x = b.split('x'); return x[0] === x[1] ? 'carre' : 'rect'; }
  function keyIn(k, sh, bk) {
    if (!k || !sh || bk < 0) return true;
    if (keyShape(k) !== sh) return false;
    var r = SHAPES.filter(function (x) { return x.s === sh; })[0].b[bk], s = keySpan(k);
    return s >= r[0] && s <= r[1];
  }
  function sizeTxt(k) { var b = k.split('|')[0]; return (b.charAt(0) === 'd' ? 'Ø' + b.slice(1) : b) + 'cm'; }
  function sizeCmp(a, b) { var x = a.split('|')[0].replace('d', '').split('x').map(Number), y = b.split('|')[0].replace('d', '').split('x').map(Number); return x[0] - y[0] || (x[1] || 0) - (y[1] || 0); }
  function bucketLabel(keys) { // tailles réellement proposées : « de 300x200cm à 400x300cm »
    var u = {}; keys.forEach(function (k) { u[k.split('|')[0]] = 1; });
    var l = Object.keys(u).sort(sizeCmp);
    if (!l.length) return '';
    if (l.length === 1) return sizeTxt(l[0]);
    return 'de ' + sizeTxt(l[0]) + ' à ' + sizeTxt(l[l.length - 1]);
  }
  function smoothTo(y) { // défilement doux, avec repli instantané si le navigateur ne l'anime pas
    if (EMB) { if (O.scroll) O.scroll(y, 'go'); return; }
    var y0 = window.pageYOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    setTimeout(function () { if (Math.abs(window.pageYOffset - y0) < 2 && Math.abs(y - y0) > 2) window.scrollTo(0, y); }, 450);
  }
  function headH() { // hauteur de l'en-tête collant du thème (le titre ne doit pas passer dessous)
    var hd = document.querySelector('.cc-header, .shopify-section-header, sticky-header');
    if (!hd) return 0;
    var ps = getComputedStyle(hd).position;
    return ps === 'sticky' || ps === 'fixed' ? hd.offsetHeight : 0;
  }
  function topOf(el) { return el.getBoundingClientRect().top + window.pageYOffset - headH() - 24; }
  function reveal(el) { // amène la suite dans l'écran si elle est hors de vue (titre visible, avec un peu d'air)
    if (!el) return;
    if (EMB) { if (O.scroll) O.scroll(topOf(el), 'reveal'); return; }
    var r = el.getBoundingClientRect();
    if (r.top > window.innerHeight - 140 || r.top < headH()) smoothTo(topOf(el));
  }
  function shapeIco(sh, bk) {
    var z = [9, 12, 15][bk], c = 'x="' + (24 - z) + '" y="' + (24 - z) + '"';
    if (sh === 'rond') return '<svg class="cfgp-shico" viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="' + z + '"/></svg>';
    if (sh === 'carre') return '<svg class="cfgp-shico" viewBox="0 0 48 48" aria-hidden="true"><rect ' + c + ' width="' + 2 * z + '" height="' + 2 * z + '"/></svg>';
    var w = Math.round(z * 2.8), h = Math.round(z * 1.8); // même proportion, la taille grandit
    return '<svg class="cfgp-shico" viewBox="0 0 48 48" aria-hidden="true"><rect x="' + (24 - w / 2) + '" y="' + (24 - h / 2) + '" width="' + w + '" height="' + h + '"/></svg>';
  }
  var CFG = O.cfg || readJSON('cfgp-cfg'); // réglages de la section (éditeur de thème)
  function keyset(s, def) { if (typeof s !== 'string' || !s.trim()) return def; var o = {}; s.toLowerCase().split(/[\s,;]+/).forEach(function (k) { if (k) o[k] = 1; }); return o; }
  var HIDE = keyset(CFG.hide, { smart: 1, twist: 1 }); // anciens modèles vendus jusqu'à épuisement du stock
  var GRP2 = { ambiente: ['deporte'], piazza: ['centre'], teakwood: ['centre'], alexo: ['bois'] }; // modèle aussi proposé dans un autre type (ALEXO = mât bois ; SMART, TWIST = alu)
  var DROPACC = { '563100': 1 };              // OSYRION LED x4 (n'existe plus)
  function niceName(mk, m) { // nom affiché = titre Shopify (avec ® imposés par Glatz)
    var t = (MODINFO[m.h] || {}).t;
    if (!t) return m.n;
    return t.replace(/^Glatz\s+/, '').replace(/^Parasol\s+/, '').replace(/\s+Parasol(\s+géant)?\s+Professionnel$/i, '').replace(/\s+Imitation bois$/i, '').trim() || m.n;
  }
  function inGroup(mk, g) { var m = D.models[mk]; return g === 'all' || m.g === g || (g === 'pro' && m.pro) || (GRP2[mk] || []).indexOf(g) >= 0; }
  var HSINC = keyset(CFG.hsinc, { sombrano: 1, sunwing: 1, pendalex: 1, sfera: 1, torna: 1, piana: 1, fortano: 1 }); // housse livrée avec le parasol
  var KTYPES = [
    { t: 'roul', l: 'Socle à roulettes', d: 'Se déplace facilement (sols lisses sans joints).' },
    { t: 'socle', l: 'Socle lesté', d: 'Posé au sol, déplaçable.' },
    { t: 'sol', l: 'Ancrage dans le sol', d: 'Douille à bétonner dans une fondation : le plus stable.' },
    { t: 'dalle', l: 'Fixation sur dalle ou terrasse', d: 'Plaque à visser sur une dalle en béton.' },
    { t: 'mur', l: 'Fixation murale', d: 'Console à fixer contre un mur porteur.' },
    { t: 'gazon', l: 'Pelouse', d: 'Pointe à planter dans le sol meuble.' },
    { t: 'table', l: 'Sur une table', d: 'Bride pour plateau de table.' }
  ];

  /* ---------- cadre ---------- */
  var formEl = $('#cfgp-offre-form');
  if (!formEl) { // hors boutique : pas de formulaire de contact
    formEl = document.createElement('form');
    formEl.id = 'cfgp-offre-form'; formEl.hidden = true;
    formEl.innerHTML = '<div class="cfgp-offre-fields" hidden><textarea class="js-cfgp-body" hidden></textarea></div>';
    root.appendChild(formEl);
  }
  var html =
    '<div class="cfgp-grid">' +
    '<div class="cfgp-main">' +
    '<section class="cfgp-step" data-step="1"><h2 class="cfgp-h"><span>1</span> Quel parasol ?</h2><div class="cfgp-body"></div></section>' +
    '<section class="cfgp-step" data-step="2" hidden><h2 class="cfgp-h"><span>2</span> Taille et toile</h2><div class="cfgp-body"></div></section>' +
    '<section class="cfgp-step" data-step="3" hidden><h2 class="cfgp-h"><span>3</span> Fixation</h2><div class="cfgp-body"></div></section>' +
    '<section class="cfgp-step" data-step="4" hidden><h2 class="cfgp-h"><span>4</span> Housse et accessoires</h2><div class="cfgp-body"></div></section>' +
    '<section class="cfgp-step" data-step="5" hidden><h2 class="cfgp-h"><span>5</span> Récapitulatif</h2><div class="cfgp-body"></div></section>' +
    '</div>' +
    '<aside class="cfgp-side" hidden><div class="cfgp-sum"></div></aside>' +
    '</div>' +
    '<div class="cfgp-bar" hidden><div class="cfgp-bar-t"></div><button type="button" class="btn btn--primary js-cfgp-tosum">Voir le récapitulatif</button></div>';
  var holder = document.createElement('div');
  holder.innerHTML = html;
  while (holder.firstChild) root.insertBefore(holder.firstChild, formEl);
  function step(n) { return $('.cfgp-step[data-step="' + n + '"]'); }
  function body(n) { return $('.cfgp-body', step(n)); }
  function show(n, on) { step(n).hidden = !on; }
  function scrollTo(n) {
    var el = step(n); if (!el || el.hidden) return;
    smoothTo(topOf(el));
  }
  if (/contact_posted=true/.test(location.search)) {
    var ok = document.createElement('div');
    ok.className = 'cfgp-banner is-ok'; ok.setAttribute('role', 'status');
    ok.textContent = 'Merci ! Votre demande d’offre nous est bien parvenue. Nous vous répondons rapidement.';
    if (!$('.cfgp-banner.is-ok', formEl)) root.insertBefore(ok, $('.cfgp-grid'));
  }

  /* ---------- étape 1 : type, taille, modèle ---------- */
  function modelSpans(m) { var ks = Object.keys(m.sz).map(keySpan); return [Math.min.apply(null, ks), Math.max.apply(null, ks)]; }
  function renderStep1() {
    var b = body(1);
    if (st.mk && !st.open1 && LOCK) {
      var lm = D.models[st.mk], linf = MODINFO[lm.h] || {};
      b.innerHTML = '<div class="cfgp-picked is-locked">' +
        (linf.img ? '<img src="' + esc(linf.img) + '" alt="" width="64" height="64">' : '') +
        '<span><strong>' + esc(lm.n) + '</strong><span class="cfgp-muted">' + esc((TYPES.filter(function (t) { return t.g === lm.g; })[0] || {}).l || '') + '</span></span></div>' +
        '<p class="cfgp-unlock"><button type="button" class="cfgp-reset js-cfgp-unlock">Voir tous les parasols Glatz</button></p>';
      return;
    }
    if (st.mk && !st.open1) {
      var mm = D.models[st.mk], inf = MODINFO[mm.h] || {};
      b.innerHTML = '<button type="button" class="cfgp-picked js-cfgp-edit1">' +
        (inf.img ? '<img src="' + esc(inf.img) + '" alt="" width="64" height="64">' : '') +
        '<span><strong>' + esc(mm.n) + '</strong><span class="cfgp-muted">' + esc((TYPES.filter(function (t) { return t.g === mm.g; })[0] || {}).l || '') + '</span></span>' +
        '<span class="cfgp-picked-edit">Changer de parasol</span></button>';
      return;
    }
    var h = '<div class="cfgp-types">' + TYPES.map(function (t) {
      return '<button type="button" class="cfgp-type' + (st.grp === t.g ? ' is-on' : '') + '" data-g="' + t.g + '">' + ico(t.g) + '<strong>' + esc(t.l) + '</strong><span>' + esc(t.d) + '</span></button>';
    }).join('') + '</div>';
    if (st.grp) {
      var inGrp = Object.keys(D.models).filter(function (mk) { return inGroup(mk, st.grp); });
      function keysIn(sh, bk) { var r = []; inGrp.forEach(function (mk) { Object.keys(D.models[mk].sz).forEach(function (k) { if (keyIn(k, sh, bk)) r.push(k); }); }); return r; }
      h += '<p class="cfgp-label cfgp-shapes-l">Forme et taille</p><div class="cfgp-shapes">' + SHAPES.map(function (S) {
        var first = true;
        return S.b.map(function (b, bk) {
          var ks = keysIn(S.s, bk), on = st.sh === S.s && st.bk === bk;
          if (!ks.length) return '';
          var row = first; first = false;
          return '<button type="button" class="cfgp-shape' + (on ? ' is-on' : '') + (row ? ' is-row' : '') + '" data-sh="' + S.s + '" data-bk="' + bk + '">' +
            shapeIco(S.s, bk) + '<span><strong>' + S.l + '</strong><span>' + bucketLabel(ks) + '</span></span></button>';
        }).join('');
      }).join('') + '</div>' +
        '<div class="cfgp-chips cfgp-chips--s cfgp-shall"><button type="button" class="' + (!st.sh ? 'is-on' : '') + '" data-sh="" data-bk="-1">Toutes les formes et tailles</button></div>';
      var list = inGrp.filter(function (mk) { return !st.sh || Object.keys(D.models[mk].sz).some(function (k) { return keyIn(k, st.sh, st.bk); }); });
      h += '<div class="cfgp-models">' + (list.length ? list.map(function (mk) {
        var m = D.models[mk], info = MODINFO[m.h] || {}, sp = modelSpans(m);
        var n = Object.keys(m.sz).filter(function (k) { return keyIn(k, st.sh, st.bk); }).length;
        return '<button type="button" class="cfgp-model' + (st.mk === mk ? ' is-on' : '') + '" data-mk="' + mk + '">' +
          (info.img ? '<img src="' + esc(info.img) + '" alt="" loading="lazy" width="240" height="240">' : '<span class="cfgp-noimg"></span>') +
          '<strong>' + esc(m.n) + '</strong>' +
          '<span class="cfgp-muted">' + (sp[0] === sp[1] ? sp[0] + 'cm' : sp[0] + ' à ' + sp[1] + 'cm') + ' · ' + n + ' taille' + (n > 1 ? 's' : '') + (st.sh ? ' dans ce choix' : '') + '</span>' +
          (info.pmin ? '<span class="cfgp-from">dès ' + money(info.pmin) + '</span>' : '') +
          (m.offre ? '<span class="cfgp-badge">Sur offre</span>' : '') +
          '</button>';
      }).join('') : '<p class="cfgp-muted">Aucun modèle dans cette taille.</p>') + '</div>';
    }
    b.innerHTML = h;
  }
  body(1).addEventListener('click', function (e) {
    var t = e.target.closest('button'); if (!t) return;
    if (t.classList.contains('js-cfgp-edit1')) { st.open1 = true; if (!st.grp) st.grp = 'all'; renderStep1(); return; }
    if (t.classList.contains('js-cfgp-unlock')) { // sortir du mode bridé : tous les parasols
      LOCK = null; st.open1 = true; st.grp = 'all';
      try { var uu = new URL(location.href); ['bride', 'variant'].forEach(function (k) { uu.searchParams.delete(k); }); history.replaceState(null, '', uu.pathname + uu.search + uu.hash); } catch (e) { /* rien */ }
      renderStep1(); return;
    }
    if (t.dataset.g) { st.grp = t.dataset.g; renderStep1(); reveal($('.cfgp-shapes-l', body(1))); return; }
    if (t.dataset.bk != null) {
      var sh = t.dataset.sh || null, bk = +t.dataset.bk;
      if (st.sh === sh && st.bk === bk) { sh = null; bk = -1; }
      st.sh = sh; st.bk = bk; renderStep1(); reveal($('.cfgp-models', body(1))); return;
    }
    if (t.dataset.mk) selectModel(t.dataset.mk);
  });

  /* ---------- étape 2 : variante du parasol ---------- */
  function M() { return D.models[st.mk]; }
  function withBal() { return st.mk === 'noblesse' || st.mk === 'royal'; }
  function selectModel(mk, vid) {
    if (st.mk !== mk) {
      st.mk = mk; st.prod = null; st.key = null; st.kit = null; st.kitReq = {}; st.kitOpt = {}; st.none = false;
      st.hs = {}; st.acc = {}; st.pz = ''; st.par = {};
    }
    st.open1 = false;
    renderStep1();
    show(2, true); [3, 4, 5].forEach(function (n) { show(n, false); });
    body(2).innerHTML = '<p class="cfgp-muted">Chargement…</p>';
    scrollTo(2);
    var m = M();
    var skus = allSkus(m);
    Promise.all([getProd(m.h, null, vid), preload(skus)]).then(function (res) {
      if (st.mk !== mk) return;
      if (!res[0]) { body(2).innerHTML = '<div class="cfgp-banner is-bad">Ce parasol n’est pas disponible en ligne pour le moment.</div>'; return; }
      setProd(res[0]);
    });
  }
  function allSkus(m) {
    var s = [];
    m.k.forEach(function (k) {
      k.main.forEach(function (o) { s.push(o.s); });
      (k.req || []).concat(k.opt || []).forEach(function (r) { r.o.forEach(function (o) { s.push(o.s); }); });
    });
    m.hs.forEach(function (x) { s.push(x.s); });
    m.a.forEach(function (x) { s.push(x.s); if (x['with']) s.push(x['with']); });
    m.o.forEach(function (x) { s.push(x.s); });
    return s;
  }
  function setProd(p) {
    st.prod = p;
    st.ovSel = p.o.map(function (o) { var v = o.vals.filter(function (x) { return x.sel; })[0] || o.vals[0]; return v.id; });
    var di = dimIndex();
    st.key = di >= 0 ? sizeKey(nameOf(di, st.ovSel[di]), withBal()) : null;
    var need = false;
    if (di >= 0 && st.sh && !keyIn(st.key, st.sh, st.bk)) {
      var vals = p.o[di].vals.filter(function (x) { return keyIn(sizeKey(x.n, withBal()), st.sh, st.bk); });
      var pick = vals.filter(function (x) { return x.x; })[0] || vals[0];
      if (pick) { st.ovSel[di] = pick.id; st.key = sizeKey(pick.n, withBal()); need = true; }
    }
    if (need || fixSel(p, di)) { loadSel(st.mk, 0, di); return; }
    renderStep2();
    afterVariant();
  }
  function dimIndex() { if (!st.prod) return -1; for (var i = 0; i < st.prod.o.length; i++) if (/dimension|taille/i.test(st.prod.o[i].n)) return i; return -1; }
  function nameOf(i, id) { var v = st.prod.o[i].vals.filter(function (x) { return x.id === id; })[0]; return v ? v.n : ''; }
  function toileLabel(n) { return String(n).replace(/^(Qualité\s*\d+\s*·\s*|Cat\.?\s*\d+\s*)/i, ''); }
  function toileQ(n) { var q = String(n).match(/^(?:Qualité|Cat\.?)\s*(\d+)/i); return q ? +q[1] : 0; }
  function toileKey(n) { return toileQ(n) + '|' + toileLabel(n); }
  function mergeToiles(o, i) { // « Cat.5 646 Rubino » et « Qualité 5 · 646 Rubino » = une seule vignette
    var by = {}, out = [];
    sortToiles(o.vals).forEach(function (x) { var k = toileKey(x.n); if (!by[k]) { by[k] = []; out.push(by[k]); } by[k].push(x); });
    return out.map(function (g) {
      var sel = g.filter(function (x) { return st.ovSel[i] === x.id; })[0];
      var pick = (sel && okVal(sel) ? sel : null) || g.filter(okVal)[0] || sel || g[0];
      var im = pick.img || (g.filter(function (x) { return x.img; })[0] || {}).img;
      return { id: pick.id, n: pick.n, x: pick.x, a: pick.a, img: im, on: !!sel };
    });
  }
  function toileNo(n) { var c = toileLabel(n).match(/^(\d+)/); return c ? +c[1] : 9999; }
  var QTXT = {
    5: 'Premium : acrylique teint dans la masse, env. 300 g/m², étanche, aspect mat, couleurs les plus durables.',
    4: 'Polyester teint dans la masse, env. 250 g/m², aspect sobre, très bonne tenue des couleurs.',
    2: 'Polyester teint en pièce, env. 220 g/m², toile légère à l’aspect brillant.'
  };
  /* ---------- vignettes de toile Glatz ----------
   * Export de Supabase « jardin-confort-database », table matieres (marque Glatz, famille toile), 21.10.2026 :
   * code 3 chiffres → [gamme_code_nom du fichier Shopify mat_glatz_toile_….jpg (2000×2000), hex fabricant].
   * À régénérer si de nouvelles toiles sont ajoutées à la table (73 toiles au 21.10.2026).
   */
  var TOILES = {
    '150': ['q2_150_eggshell', '#DED4C0'], '151': ['q2_151_ash', '#ABA8A1'], '156': ['q2_156_pale-grey', '#B2B4B2'], '157': ['q2_157_stone-grey', '#5B5B5B'],
    '158': ['q2_158_off-white', '#D6D2C4'], '403': ['q4_403_carmine', '#A53430'], '404': ['q4_404_white', '#F4F3EB'], '408': ['q4_408_black', '#2F2A26'],
    '416': ['q4_416_caribbean', '#009C9B'], '417': ['q4_417_ocean', '#7F9C90'], '418': ['q4_418_cobalt', '#326295'], '420': ['q4_420_smoke', '#959697'],
    '422': ['q4_422_cream', '#CDC7B7'], '436': ['q4_436_wine', '#6C333A'], '438': ['q4_438_straw', '#F6C87D'], '453': ['q4_453_vanilla', '#E6DDD8'],
    '461': ['q4_461_taupe', '#9C998B'], '500': ['q5_500_plaster', '#E8E9E4'], '501': ['q5_501_granite', '#999999'], '502': ['q5_502_thunder', '#575653'],
    '509': ['q5_509_slate', '#75787B'], '510': ['q5_510_white', '#EEF0E8'], '513': ['q5_513_outback', '#932930'], '514': ['q5_514_corn', '#F5AB32'],
    '515': ['q5_515_cloud', '#6A94B5'], '521': ['q5_521_aloe', '#244434'], '523': ['q5_523_champagne', '#EAE2D5'], '526': ['q5_526_bamboo', '#BEAC84'],
    '527': ['q5_527_urban-chrome', '#9B9A97'], '530': ['q5_530_atlantic', '#253145'], '550': ['q5_550_cement', '#D0D3D4'], '555': ['q5_555_grey-stripe', '#A2AAAD'],
    '556': ['q5_556_alabaster', '#C7C9C7'], '558': ['q5_558_steel', '#A59C94'], '570': ['q5_570_steel-stripe', '#A59C94'], '579': ['q5_579_pistachio', '#9CAF88'],
    '581': ['q5_581_jade', '#94A596'], '588': ['q5_588_olive', '#708573'], '589': ['q5_589_green-stripe', '#00594C'], '600': ['q5_600_wave', '#236192'],
    '601': ['q5_601_waterfall', '#5B7F95'], '602': ['q5_602_blue-stripe', '#151F6D'], '603': ['q5_603_horizon', '#768692'], '604': ['q5_604_cereal', '#D29F13'],
    '605': ['q5_605_clay', '#A29F91'], '611': ['q5_611_sandstone', '#827C70'], '615': ['q5_615_black', '#27201A'], '617': ['q5_617_safran', '#F1BE48'],
    '618': ['q5_618_dijon', '#9F7D23'], '624': ['q5_624_yellow-stripe', '#F1BE48'], '637': ['q5_637_cherry', '#9B2743'], '639': ['q5_639_blush', '#CA9A8E'],
    '644': ['q5_644_merlot', '#874B52'], '645': ['q5_645_burgundy', '#550528'], '646': ['q5_646_rubino', '#9C0F1E'], '650': ['q5_650_camel', '#AA9B88'],
    '652': ['q5_652_silver', '#A3A09F'], '657': ['q5_657_sky', '#8CA8CD'], '660': ['q5_660_papaya', '#CC5D42'], '665': ['q5_665_chrome', '#C1C7C7'],
    '669': ['q5_669_carbone', '#4D4D4B'], '677': ['q5_677_nile', '#5F7756'], '684': ['q5_684_urban-shadow', '#8A8D8C'], '686': ['q5_686_urban-clay', '#B8B2AB'],
    '800': ['q5_800_red-stripe', '#9D2235'], '801': ['q5_801_campari', '#A6192E'], '802': ['q5_802_sienna', '#DB864E'], '803': ['q5_803_linen', '#C5B9AC'],
    '805': ['q5_805_walnut', '#7A6855'], '806': ['q5_806_forge', '#707372'], '807': ['q5_807_lava', '#63666A'], '809': ['q5_809_midnight', '#3D3935'],
    '810': ['q5_810_black-stripe', '#3D3935']
  };
  var TFILES = 'https://cdn.shopify.com/s/files/1/0360/3251/2135/files/mat_glatz_toile_';
  function tInfo(n) { // toile d'une valeur d'option (par le code à 3 chiffres)
    var c = String(toileNo(n)), t = TOILES[c];
    return t ? { c: c, url: TFILES + t[0] + '.jpg', hex: t[1], lab: toileLabel(n).replace(/\s*\(.*?\)\s*$/, ''), q: toileQ(n) } : null;
  }
  function tSrc(t, w) { return t.url + '?width=' + w; }
  function curToile() {
    var p = st.prod; if (!p) return null;
    for (var i = 0; i < p.o.length; i++) if (isToileOpt(p.o[i])) {
      var v = p.o[i].vals.filter(function (x) { return x.id === st.ovSel[i]; })[0];
      return v ? tInfo(v.n) : null;
    }
    return null;
  }
  function swatch(t, w, cls) { return t ? '<span class="cfgp-sw ' + (cls || '') + '" style="background:' + t.hex + '"><img src="' + esc(tSrc(t, w)) + '" alt="" loading="lazy"></span>' : ''; }
  function qtxt(q) { return (QTXT[q] ? QTXT[q] + ' ' : '') + (q >= 5 ? 'Toile réparable.' : 'Toile non réparable.'); }
  function sortToiles(vals) { return vals.slice().sort(function (a, b) { return toileQ(b.n) - toileQ(a.n) || toileNo(a.n) - toileNo(b.n) || (a.n < b.n ? -1 : 1); }); }
  function isToileOpt(o) { return /tissu|toile/i.test(o.n) && o.vals.length > 3; }
  function okVal(x) { return x.x && x.a !== false; }
  function fixSel(p, lock) { // une valeur choisie n'existe pas avec les autres → on change une AUTRE option (la toile d'abord)
    var idx = p.o.map(function (o, i) { return i; }).filter(function (i) { return i !== lock; });
    idx.sort(function (a, b) { return (isToileOpt(p.o[b]) ? 1 : 0) - (isToileOpt(p.o[a]) ? 1 : 0); });
    var bad = p.miss || p.o.some(function (o, i) { var c = o.vals.filter(function (x) { return x.id === st.ovSel[i]; })[0]; return c && !okVal(c); });
    if (!bad) return false;
    for (var k = 0; k < idx.length; k++) {
      var i = idx[k], o = p.o[i];
      var cur = o.vals.filter(function (x) { return x.id === st.ovSel[i]; })[0];
      if (cur && okVal(cur)) continue;
      var alt = isToileOpt(o) && cur ? o.vals.filter(function (x) { return okVal(x) && toileKey(x.n) === toileKey(cur.n); })[0] : null; // même toile, autre libellé
      alt = alt || (isToileOpt(o) ? sortToiles(o.vals) : o.vals).filter(okVal)[0];
      if (alt && (!cur || alt.id !== cur.id)) { st.ovSel[i] = alt.id; return true; }
    }
    return false;
  }
  function selOk(p, i) { var c = p.o[i] && p.o[i].vals.filter(function (x) { return x.id === st.ovSel[i]; })[0]; return !p.miss && (!c || okVal(c)); }
  function tryOthers(mk, lock, p0) { // la valeur cliquée n'existe pas avec les autres choix : on essaie les autres finitions (armature…)
    var di = -1; p0.o.forEach(function (o, i) { if (/dimension|taille/i.test(o.n)) di = i; });
    var base = st.ovSel.slice(), cands = [];
    p0.o.forEach(function (o, j) {
      if (j === lock || j === di || isToileOpt(o)) return;
      o.vals.forEach(function (x) { if (x.id !== base[j]) cands.push([j, x.id]); });
    });
    function next(k) {
      if (k >= cands.length) { st.ovSel = base; return loadSel(mk, 'alt', lock); }
      st.ovSel = base.slice(); st.ovSel[cands[k][0]] = cands[k][1];
      return getProd(M().h, st.ovSel.join(',')).then(function (p) {
        if (st.mk !== mk) return;
        if (p && selOk(p, lock)) return loadSel(mk, 'alt', lock);
        return next(k + 1);
      });
    }
    return next(0);
  }
  function loadSel(mk, tries, lock) { // charge la combinaison choisie ; si elle n'existe pas, ajuste les autres options
    return getProd(M().h, st.ovSel.join(',')).then(function (p) {
      if (!p || st.mk !== mk) { var pv = $('.cfgp-pv', body(2)); if (pv) pv.classList.remove('is-loading'); return; }
      if (tries !== 'alt' && (tries || 0) < 3 && fixSel(p, lock)) return loadSel(mk, (tries || 0) + 1, lock);
      if (lock != null && tries !== 'alt' && !selOk(p, lock)) return tryOthers(mk, lock, p);
      if (p.miss) { var vv = {}; Object.keys(p.v).forEach(function (k) { vv[k] = p.v[k]; }); vv.a = false; p.v = vv; } // combinaison inexistante : pas de panier
      st.prod = p;
      st.ovSel = p.o.map(function (o, i) { var v = o.vals.filter(function (x) { return x.sel; })[0]; return v ? v.id : st.ovSel[i]; });
      var di = dimIndex(); if (di >= 0) st.key = sizeKey(nameOf(di, st.ovSel[di]), withBal());
      renderStep2(); afterVariant();
    });
  }
  function renderStep2() {
    var p = st.prod, m = M(), v = p.v;
    var h = '<div class="cfgp-pv">' +
      '<div class="cfgp-pv-img">' + (v.img ? '<img src="' + esc(v.img) + '" alt="">' : '') + swatch(curToile(), 160, 'cfgp-sw--pv') + '</div>' +
      '<div class="cfgp-pv-info"><p class="cfgp-pv-t"><a href="' + esc(BASE + p.u) + '?variant=' + v.id + '" target="_blank" rel="noopener">' + esc(p.t) + '</a></p>' +
      '<p class="cfgp-pv-v">' + esc(v.t) + '</p>' +
      '<p class="cfgp-price">' + money(v.p) + '</p>' +
      '<p class="cfgp-stock' + (v.a ? '' : ' is-bad') + '">' + esc(v.a ? (v.sk || '') : 'Indisponible dans cette combinaison') + '</p></div></div>';
    var ord = p.o.map(function (o, i) { return i; });
    ord.sort(function (a, b) { var ta = /tissu|toile/i.test(p.o[a].n) ? 1 : 0, tb = /tissu|toile/i.test(p.o[b].n) ? 1 : 0; return ta - tb || a - b; });
    ord.forEach(function (i) {
      var o = p.o[i];
      var isDim = /dimension|taille/i.test(o.n), isToile = isToileOpt(o);
      h += '<p class="cfgp-label">' + esc(o.n) + '</p>';
      if (isToile) {
        var groups = [], gq = {};
        mergeToiles(o, i).forEach(function (x) { var q = toileQ(x.n); if (!gq[q]) { gq[q] = []; groups.push(q); } gq[q].push(x); });
        h += '<div class="cfgp-toiles-wrap">' + groups.map(function (q) {
          return (q ? '<p class="cfgp-tq"><strong>Qualité ' + q + '</strong>' + ' <span class="cfgp-muted">— ' + esc(qtxt(q)) + '</span>' + '</p>' : '') +
            '<div class="cfgp-toiles">' + gq[q].map(function (x) {
              var ti = tInfo(x.n);
              var na = !okVal(x) && !x.on; // indisponible : on montre la couleur, barrée, sans pouvoir la choisir
              return '<button type="button" class="cfgp-toile' + (x.on ? ' is-on' : '') + (okVal(x) ? '' : ' is-x') + '" data-i="' + i + '" data-id="' + x.id + '"' + (na ? ' aria-disabled="true"' : '') + (ti ? ' data-tc="' + ti.c + '" data-tn="' + esc(x.n) + '"' : ' title="' + esc(x.n) + (okVal(x) ? '' : ' — indisponible dans cette configuration') + '"') + '>' +
                '<span class="cfgp-toile-im">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="80" height="80">' : (ti ? '<span class="cfgp-noimg" style="background:' + ti.hex + '"></span>' : '<span class="cfgp-noimg"></span>')) + swatch(ti, 64, 'cfgp-sw--dot') + (okVal(x) ? '' : '<span class="cfgp-toile-x" aria-hidden="true"></span>') + '</span>' +
                '<span>' + esc(toileLabel(x.n)) + '</span>' + (okVal(x) ? '' : '<small class="cfgp-toile-na">Indisponible</small>') + '</button>';
            }).join('') + '</div>';
        }).join('') + '</div>';
      } else {
        h += '<div class="cfgp-chips">' + o.vals.map(function (x) {
          var lab = esc(x.n);
          return '<button type="button" class="' + (st.ovSel[i] === x.id ? 'is-on' : '') + (x.x ? '' : ' is-x') + '" data-i="' + i + '" data-id="' + x.id + '">' + lab + '</button>';
        }).join('') + '</div>';
        if (isDim && st.key && m.sz[st.key]) h += '<p class="cfgp-muted cfgp-minkg">Pour cette taille, Glatz demande un socle d’au moins ' + m.sz[st.key].kg + 'kg : seules les fixations adaptées sont proposées à l’étape 3.</p>';
      }
    });
    if (m.offre) h += '<div class="cfgp-banner">Ce parasol professionnel se commande <strong>sur offre</strong> : configurez-le, nous vous envoyons une offre détaillée (vous pouvez aussi l’ajouter au panier).</div>';
    body(2).innerHTML = h;
  }
  var tpop = document.createElement('div');
  tpop.className = 'cfgp-tpop'; tpop.hidden = true;
  tpop.innerHTML = '<img alt=""><p></p>';
  root.appendChild(tpop);
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function popShow(btn) {
    var t = tInfo(btn.dataset.tn || ''); if (!t) return;
    var im = $('img', tpop), src = tSrc(t, 600);
    if (im.getAttribute('src') !== src) { im.src = src; im.style.background = t.hex; }
    $('p', tpop).innerHTML = esc(t.lab) + (t.q ? '<span>Qualité ' + t.q + ' — ' + (t.q >= 5 ? 'toile réparable' : 'toile non réparable') + '</span>' : '') +
      (btn.classList.contains('is-x') ? '<span class="cfgp-tpop-na">Indisponible dans cette configuration (taille, armature)</span>' : '');
    tpop.hidden = false;
    var r = btn.getBoundingClientRect(), w = tpop.offsetWidth, h = tpop.offsetHeight;
    var x = Math.max(8, Math.min(window.innerWidth - w - 8, r.left + r.width / 2 - w / 2));
    var y = r.top - h - 10;
    if (y < headH() + 8) y = r.bottom + 10;
    tpop.style.left = x + 'px'; tpop.style.top = y + 'px';
  }
  var popT = 0;
  function popHide() { tpop.hidden = true; }
  if (canHover) {
    body(2).addEventListener('mouseover', function (e) { var b = e.target.closest('.cfgp-toile[data-tc]'); if (b) popShow(b); });
    body(2).addEventListener('mouseout', function (e) { var b = e.target.closest('.cfgp-toile[data-tc]'); if (b && !b.contains(e.relatedTarget)) popHide(); });
    window.addEventListener('scroll', popHide, { passive: true });
  }
  body(2).addEventListener('click', function (e) {
    var t = e.target.closest('button[data-id]'); if (!t || !st.prod) return;
    if (t.getAttribute('aria-disabled') === 'true') { // toile indisponible : zoom seulement
      popShow(t); clearTimeout(popT); popT = setTimeout(popHide, canHover ? 4000 : 2500); return;
    }
    popHide();
    var i = +t.dataset.i, id = +t.dataset.id;
    st.ovSel[i] = id;
    var di = dimIndex();
    if (i === di) st.key = sizeKey(nameOf(di, id), withBal());
    $$('button[data-i="' + i + '"]', body(2)).forEach(function (b) { b.classList.toggle('is-on', +b.dataset.id === id); });
    $('.cfgp-pv', body(2)).classList.add('is-loading');
    loadSel(st.mk, 0, i);
  });

  /* ---------- étape 3 : fixation ---------- */
  function minKg() {
    var m = M(), z = st.key && m.sz[st.key];
    if (z) return { kg: z.kg, z: z, exact: true };
    var max = 0; Object.keys(m.sz).forEach(function (k) { max = Math.max(max, m.sz[k].kg); });
    return { kg: max, z: null, exact: false };
  }
  function kitKg(k) {
    if (!k.kg) return null;
    var kg = k.kg;
    (k.req || []).forEach(function (r, ri) {
      var sel = st.kit === k.id ? st.kitReq[ri] : null;
      var o = r.o.filter(function (x) { return x.s === sel; })[0] || r.o[0];
      if (o && o.kg) kg = o.kg;
    });
    return kg;
  }
  function okKit(k, min) { if (!k.kg) return true; var best = k.kg; (k.req || []).forEach(function (r) { r.o.forEach(function (o) { if (o.kg) best = Math.max(o.kg, best); }); }); return best >= min; }
  function defaultOpt(list, min) { // premier choix vendu en ligne, sinon le premier
    var ok = list.filter(function (o) { return (!o.kg || o.kg >= min) && inShop(o.s); })[0];
    return (ok || list.filter(function (o) { return !o.kg || o.kg >= min; })[0] || list[0]).s;
  }
  function kitMain(k) { return st.kit === k.id && st.kitReq.main ? st.kitReq.main : defaultOpt(k.main, 0); }
  function kitLines(k) { // lignes du kit selon les choix
    var min = minKg().kg, lines = [];
    lines.push({ s: st.kit === k.id && st.kitReq.main ? st.kitReq.main : defaultOpt(k.main, 0), q: 1, role: 'main' });
    (k.req || []).forEach(function (r, ri) {
      var s = st.kit === k.id && st.kitReq[ri] ? st.kitReq[ri] : defaultOpt(r.o, min);
      lines.push({ s: s, q: 1, role: 'req', l: r.l });
    });
    if (st.kit === k.id) (k.opt || []).forEach(function (r, ri) {
      if (st.kitOpt[ri]) lines.push({ s: st.kitOpt[ri], q: 1, role: 'opt', l: r.l });
    });
    return lines;
  }
  function linesPrice(lines) { return lines.reduce(function (a, l) { var p = unitPrice(l.s); return a + (p || 0) * l.q; }, 0); }
  function kitAvail(k) { return inShop(kitMain(k)); }
  function renderStep3() {
    var m = M(), mn = minKg();
    var h = '<div class="cfgp-rule">' +
      (mn.exact ? 'Pour ' + esc(keyLabel(st.key)) + ', Glatz exige un socle d’au moins <strong>' + mn.kg + 'kg</strong>' +
        (mn.z.f ? ' (ou une fondation de ' + esc(String(mn.z.f).replace(/\s*x\s*/g, 'x')) + 'cm)' : '') + '.' + (mn.z.v ? ' Vent max. parasol ouvert : ' + esc(mn.z.v) + '.' : '')
        : 'Poids minimum Glatz non publié pour cette taille : par prudence, seuls les socles d’au moins <strong>' + mn.kg + 'kg</strong> sont proposés.') +
      ' <span class="cfgp-muted">Au-delà de cette valeur de vent, ou en cas de rafales, un ancrage fixe est nécessaire.</span></div>';
    var shownAny = false, tooLight = [], onReq = [];
    KTYPES.forEach(function (T) {
      var ks = m.k.filter(function (k) { return k.t === T.t; });
      var good = ks.filter(function (k) { return okKit(k, mn.kg); });
      ks.filter(function (k) { return !okKit(k, mn.kg); }).forEach(function (k) { tooLight.push(k.l); });
      var shop = good.filter(kitAvail), other = good.filter(function (k) { return !kitAvail(k); });
      other.forEach(function (k) { onReq.push(k); });
      if (!shop.length) return;
      shownAny = true;
      h += '<p class="cfgp-group">' + esc(T.l) + ' <span class="cfgp-muted">— ' + esc(T.d) + '</span></p>';
      shop.forEach(function (k) { h += kitCard(k, mn.kg); });
    });
    if (onReq.length) {
      h += '<details class="cfgp-more"' + (onReq.some(function (k) { return k.id === st.kit; }) ? ' open' : '') + '><summary>Autres fixations Glatz compatibles (sur demande, ' + onReq.length + ')</summary>' +
        onReq.map(function (k) { return kitCard(k, mn.kg); }).join('') + '</details>';
    }
    h += '<label class="cfgp-none"><input type="radio" name="cfgp-kit" value=""' + (st.none ? ' checked' : '') + '> Pas de fixation, j’en ai déjà une</label>';
    if (tooLight.length) h += '<p class="cfgp-muted cfgp-light">Trop légers pour cette taille : ' + esc(tooLight.join(', ')) + '.</p>';
    if (!shownAny && !onReq.length) h += '<div class="cfgp-banner is-warn">Aucune fixation listée par Glatz pour ce modèle — demandez-nous conseil.</div>';
    body(3).innerHTML = h;
  }
  /* ================================================================================
   * IMAGE DE LA CARTE FIXATION — À RETENIR EN AJOUTANT UN ARTICLE :
   * balise dans le TEXTE ALTERNATIF d'une image de l'article principal du kit OU d'un de ses
   * accessoires (ex. cache, plaque décorative ; lu seulement si l'accessoire est choisi) :
   *   [configurateur]                        toutes variantes
   *   [configurateur Anthracite]             variante « Anthracite » de l'article principal
   *   [configurateur Blanc mat / Anthracite] + un accessoire du kit en « Anthracite »
   * Termes = titres exacts des variantes Shopify, séparés par « / » ; 1er terme = article
   * principal (vide s'il n'a pas de variantes). Toutes les conditions doivent être remplies ;
   * l'image la plus précise gagne. Sinon : image de la variante, sinon 1re image du produit.
   * Liste « cfgi » fournie par templates/product.cfgparasol.liquid.
   * ================================================================================ */
  function kitImg(main, lines) {
    var r = R[main]; if (!r) return null;
    var mv = String(r.vt || '').toLowerCase().trim(), dft = !mv || mv === 'default title';
    var acc = lines.filter(function (l) { return l.s !== main; }).map(function (l) { var x = R[l.s]; return x && x.vt ? String(x.vt).toLowerCase().trim() : ''; });
    var best = null, bs = -1, cands = (r.cfgi || []).slice();
    lines.forEach(function (l) { var x = R[l.s]; if (l.s !== main && x && x.cfgi) cands = cands.concat(x.cfgi); }); // images balisées des accessoires du kit aussi
    cands.forEach(function (c) {
      var ok = true, sc = 0;
      String(c.t || '').split('/').forEach(function (t, i) {
        t = t.trim().toLowerCase(); if (!t || !ok) return;
        if (i === 0 && !dft) { if (t === mv) sc += 10; else ok = false; return; }
        if (acc.indexOf(t) >= 0) sc += 1; else ok = false;
      });
      if (ok && sc > bs) { bs = sc; best = c.u; }
    });
    return best || r.img;
  }
  function kitCard(k, min) {
    var on = st.kit === k.id, lines = kitLines(k), price = linesPrice(lines);
    var hors = lines.some(function (l) { return !inShop(l.s); });
    var main = kitMain(k), r = R[main], kimg = kitImg(main, lines);
    var h = '<div class="cfgp-kit' + (on ? ' is-on' : '') + '" data-kit="' + esc(k.id) + '">' +
      '<label class="cfgp-kit-head"><input type="radio" name="cfgp-kit" value="' + esc(k.id) + '"' + (on ? ' checked' : '') + '>' +
      (kimg ? '<img src="' + esc(kimg) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="cfgp-noimg cfgp-noimg--s"></span>') +
      '<span class="cfgp-kit-t"><strong>' + esc(k.l) + '</strong>' +
      (k.kg ? ' <span class="cfgp-kg">' + kitKg(k) + 'kg</span>' : '') +
      '<span class="cfgp-muted">' + lines.length + ' article' + (lines.length > 1 ? 's' : '') + ' (pièces indispensables comprises)' + (hors ? ' · en partie sur offre' : '') + '</span></span>' +
      '<span class="cfgp-kit-p"><small>' + (lines.length > 1 ? 'prix total, ' + lines.length + ' articles' : 'prix') + '</small>' + money(price) + '</span></label>';
    if (on) {
      h += '<div class="cfgp-kit-detail">';
      if (k.main.length > 1) h += choiceRow('Finition', 'main', k.main, st.kitReq.main || defaultOpt(k.main, 0), min, true);
      (k.req || []).forEach(function (rq, ri) {
        h += choiceRow(rq.l, ri, rq.o, st.kitReq[ri] || defaultOpt(rq.o, min), min, true);
      });
      (k.opt || []).forEach(function (op, ri) {
        h += choiceRow(op.l + ' (option)', 'o' + ri, op.o, st.kitOpt[ri] || '', min, false);
      });
      if (k.excl) h += '<p class="cfgp-note">' + esc(k.excl.n) + '</p>';
      if (k.note) h += '<p class="cfgp-note">' + esc(k.note) + '</p>';
      h += '<p class="cfgp-kit-dl">Détail du prix total</p><ul class="cfgp-kit-lines">' + lines.map(function (l) { return lineLi(l.s, l.q, l.role === 'req' ? 'indispensable' : (l.role === 'opt' ? 'option' : '')); }).join('') + '</ul>';
      h += '</div>';
    }
    return h + '</div>';
  }
  function choiceRow(lab, key, list, sel, min, req) {
    var h = '<div class="cfgp-choice"><span class="cfgp-choice-l">' + esc(lab) + (req ? ' <em>indispensable</em>' : '') + '</span><div class="cfgp-chips cfgp-chips--s">';
    if (!req) h += '<button type="button" class="' + (!sel ? 'is-on' : '') + '" data-ck="' + key + '" data-s="">Sans</button>';
    list.forEach(function (o) {
      var dis = o.kg && o.kg < min;
      var p = unitPrice(o.s);
      h += '<button type="button" class="' + (sel === o.s ? 'is-on' : '') + (dis ? ' is-x' : '') + '" data-ck="' + key + '" data-s="' + o.s + '"' + (dis ? ' disabled' : '') + '>' +
        esc(o.l || label(o.s)) + (p != null ? ' <small>' + money(p) + '</small>' : '') + (inShop(o.s) ? '' : ' <small class="cfgp-onreq">sur offre</small>') + '</button>';
    });
    return h + '</div></div>';
  }
  function lineLi(s, q, tag) {
    var r = R[s], p = unitPrice(s);
    return '<li><span class="cfgp-li-t">' + (q > 1 ? q + ' × ' : '') + esc(label(s)) + ' <span class="cfgp-ref">' + esc(s) + '</span>' +
      (tag ? ' <em class="cfgp-tag">' + esc(tag) + '</em>' : '') +
      (inShop(s) ? (r.sk ? ' <span class="cfgp-muted">· ' + esc(r.sk) + '</span>' : '') : ' <span class="cfgp-onreq">sur offre</span>') +
      '</span><span class="cfgp-li-p">' + (p != null ? money(p * q) : '') + '</span></li>';
  }
  body(3).addEventListener('change', function (e) {
    if (e.target.name !== 'cfgp-kit') return;
    var id = e.target.value;
    st.none = !id;
    if (st.kit !== id) { st.kit = id || null; st.kitReq = {}; st.kitOpt = {}; }
    renderStep3(); refresh();
  });
  body(3).addEventListener('click', function (e) {
    var b = e.target.closest('button[data-ck]'); if (!b || b.disabled) return;
    var ck = b.dataset.ck, s = b.dataset.s;
    if (ck === 'main') st.kitReq.main = s;
    else if (ck.charAt(0) === 'o') {
      var oi = +ck.slice(1), kk = M().k.filter(function (x) { return x.id === st.kit; })[0];
      st.kitOpt[oi] = s;
      if (s && kk && kk.excl && (oi === kk.excl.a || oi === kk.excl.b)) st.kitOpt[oi === kk.excl.a ? kk.excl.b : kk.excl.a] = ''; // roues OU cache-socle
    }
    else st.kitReq[+ck] = s;
    renderStep3(); refresh();
  });

  /* ---------- étape 4 : housse, accessoires, options sur offre ---------- */
  function houssesFor() { var m = M(); if (HSINC[st.mk]) return []; return m.hs.filter(function (x) { return !x.z || !st.key || x.z.indexOf(st.key.split('|')[0]) >= 0; }); }
  function accFor() { var m = M(); return m.a.filter(function (x) { return !x.z || !st.key || x.z.indexOf(st.key.split('|')[0]) >= 0; }); }
  function parFor() {
    var m = M(), sides = st.key ? keySides(st.key) : [];
    return m.o.filter(function (x) {
      if (!/^Paroi/.test(x.n)) return false;
      var w = +((x.n.match(/Paroi latérale\s*(\d+)/) || [])[1]);
      return sides.indexOf(w) >= 0;
    });
  }
  function pzFor() { return M().o.filter(function (x) { return /Pz200|^LED|^Motorisation/.test(x.n); }); }
  function renderStep4() {
    var h = '', hs = houssesFor(), ac = accFor();
    if (hs.length) {
      h += '<p class="cfgp-group">Housse de protection</p>';
      hs.forEach(function (x) {
        if (!(x.s in st.hs)) st.hs[x.s] = true; // cochée d'office
        h += accRow(x.s, 'hs', st.hs[x.s] ? 1 : 0, false, 'Protège la toile quand le parasol est fermé.');
      });
    }
    if (HSINC[st.mk]) h += '<p class="cfgp-group">Housse de protection</p><p class="cfgp-incl">✓ Housse de protection livrée avec ce parasol.</p>';
    var groups = {};
    ac.forEach(function (x) { (groups[x.c] = groups[x.c] || []).push(x); });
    Object.keys(groups).forEach(function (c) {
      h += '<p class="cfgp-group">' + esc(c) + '</p>';
      groups[c].forEach(function (x) {
        var q = st.acc[x.s] || 0;
        var note = x.c === 'Chauffage radiant' ? 'Nécessite une commande Pz200 « chauffages radiants » (options montées en usine ci-dessous). Un raccord par chauffage est ajouté d’office. 4 chauffages max.' : '';
        h += accRow(x.s, 'acc', q, x.q || 0, note);
      });
    });
    var pz = pzFor(), par = parFor();
    if (pz.length || par.length) {
      h += '<p class="cfgp-group">Options montées en usine et sur mesure <span class="cfgp-muted">— montées en usine, à choisir avec le parasol</span></p>';
      if (pz.length) {
        h += '<div class="cfgp-pz"><label><input type="radio" name="cfgp-pz" value=""' + (!st.pz ? ' checked' : '') + '> Aucune commande intégrée</label>' +
          pz.map(function (x) {
            return '<label><input type="radio" name="cfgp-pz" value="' + esc(x.s) + '"' + (st.pz === x.s ? ' checked' : '') + '><span class="cfgp-acc-t">' + esc(x.n) +
              ' <span class="cfgp-ref">' + esc(x.s) + '</span>' + (inShop(x.s) ? '' : ' <span class="cfgp-onreq">sur offre</span>') +
              '</span><span class="cfgp-li-p">' + (inShop(x.s) ? money(unitPrice(x.s)) : (x.pvi != null ? money(pvi(x.pvi)) : '')) + '</span></label>';
          }).join('') + '</div>';
      }
      if (par.length) {
        h += '<p class="cfgp-label">Parois latérales <span class="cfgp-muted">(dans la couleur de la toile)</span></p>';
        par.forEach(function (x) { h += accRow(x.s, 'par', st.par[x.s] || 0, 4, '', x); });
      }
    }
    if (!h) h = '<p class="cfgp-muted">Pas d’accessoire listé pour ce modèle.</p>';
    body(4).innerHTML = h;
  }
  function accRow(s, kind, q, max, note, off) {
    var r = R[s], p = off ? pvi(off.pvi) : unitPrice(s), t = off ? off.n : label(s);
    var ctrl = max
      ? '<select data-kind="' + kind + '" data-s="' + s + '">' + Array.apply(null, Array(max + 1)).map(function (_, i) { return '<option value="' + i + '"' + (i === q ? ' selected' : '') + '>' + i + '</option>'; }).join('') + '</select>'
      : '<input type="checkbox" data-kind="' + kind + '" data-s="' + s + '"' + (q ? ' checked' : '') + '>';
    return '<label class="cfgp-acc">' + ctrl +
      (r && r.img ? '<img src="' + esc(r.img) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="cfgp-noimg cfgp-noimg--s"></span>') +
      '<span class="cfgp-acc-t">' + esc(t) + ' <span class="cfgp-ref">' + esc(s) + '</span>' +
      (off || !inShop(s) ? ' <span class="cfgp-onreq">sur offre</span>' : (r.sk ? ' <span class="cfgp-muted">· ' + esc(r.sk) + '</span>' : '')) +
      (note ? '<span class="cfgp-muted cfgp-acc-n">' + esc(note) + '</span>' : '') + '</span>' +
      '<span class="cfgp-li-p">' + (p != null ? money(p) : '') + '</span></label>';
  }
  body(4).addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'cfgp-pz') { st.pz = t.value; refresh(); return; }
    var s = t.dataset.s, kind = t.dataset.kind; if (!s) return;
    var q = t.type === 'checkbox' ? (t.checked ? 1 : 0) : +t.value;
    if (kind === 'hs') st.hs[s] = !!q;
    else if (kind === 'acc') st.acc[s] = q;
    else if (kind === 'par') st.par[s] = q;
    refresh();
  });

  /* ---------- récapitulatif ---------- */
  function buildLines() {
    var L = [], m = M(), v = st.prod && st.prod.v;
    if (!v) return L;
    L.push({ g: 'Parasol', t: st.prod.t + ' — ' + v.t, s: v.sku, q: 1, p: v.p, shop: !!v.a, vid: v.id, main: true, img: v.img, tag: HSINC[st.mk] ? 'housse incluse' : '' });
    var k = st.kit && m.k.filter(function (x) { return x.id === st.kit; })[0];
    if (k) kitLines(k).forEach(function (l) { L.push(line('Fixation', l.s, l.q, l.role === 'req' ? 'indispensable' : '')); });
    Object.keys(st.hs).forEach(function (s) { if (st.hs[s] && houssesFor().some(function (x) { return x.s === s; })) L.push(line('Housse', s, 1)); });
    accFor().forEach(function (x) {
      var q = st.acc[x.s] || 0; if (!q) return;
      L.push(line('Accessoires', x.s, q));
      if (x['with']) L.push(line('Accessoires', x['with'], q, 'indispensable'));
    });
    if (st.pz) { var o = M().o.filter(function (x) { return x.s === st.pz; })[0]; if (o) L.push(inShop(o.s) ? line('Accessoires', o.s, 1) : { g: 'Sur offre', t: o.n, s: o.s, q: 1, p: pvi(o.pvi), shop: false }); }
    parFor().forEach(function (x) { var q = st.par[x.s] || 0; if (q) L.push({ g: 'Sur offre', t: x.n, s: x.s, q: q, p: pvi(x.pvi), shop: false }); });
    return L;
  }
  function line(g, s, q, tag) {
    var r = R[s], shop = !!(r && r.a);
    return { g: shop ? g : 'Sur offre', t: label(s), s: s, q: q, p: unitPrice(s), shop: shop, vid: shop ? r.vid : null, tag: tag || '', img: r && r.img };
  }
  function totals(L) {
    var a = 0, b = 0;
    L.forEach(function (l) { if (l.p == null) return; if (l.shop) a += l.p * l.q; else b += l.p * l.q; });
    return { shop: a, off: b, all: a + b };
  }
  function warnings(L) {
    var w = [], m = M();
    if (!st.kit && !st.none) w.push('Choisissez une fixation (ou « Pas de fixation »).');
    var chauff = accFor().some(function (x) { return x.c === 'Chauffage radiant' && st.acc[x.s]; });
    if (chauff && !(st.pz && /chauffage/i.test((m.o.filter(function (x) { return x.s === st.pz; })[0] || {}).n || ''))) w.push('Les chauffages radiants nécessitent une commande Pz200 avec chauffage (options montées en usine).');
    if (st.prod && !st.prod.v.a) w.push('Cette combinaison de parasol n’est pas disponible.');
    return w;
  }
  function renderSum() {
    var L = buildLines(), T = totals(L), m = M();
    var groups = ['Parasol', 'Fixation', 'Housse', 'Accessoires', 'Sur offre'];
    var tc = curToile();
    var h = '<p class="cfgp-sum-t">' + esc(m.n) + (st.key ? ' · ' + esc(keyLabel(st.key)) : '') + '</p>' +
      (tc ? '<p class="cfgp-sum-tl">' + swatch(tc, 80, 'cfgp-sw--s') + 'Toile ' + esc(tc.lab) + (tc.q ? ' · Qualité ' + tc.q : '') + '</p>' : '');
    groups.forEach(function (g) {
      var ls = L.filter(function (l) { return l.g === g; }); if (!ls.length) return;
      h += '<p class="cfgp-sum-g">' + esc(g) + (g === 'Sur offre' ? ' <span class="cfgp-muted">(prix catalogue Glatz TTC, indicatif)</span>' : '') + '</p><ul>' +
        ls.map(function (l) {
          return '<li><span>' + (l.q > 1 ? l.q + ' × ' : '') + esc(l.t) + (l.tag ? ' <em class="cfgp-tag">' + esc(l.tag) + '</em>' : '') + '</span><span class="cfgp-li-p">' + (l.p != null ? money(l.p * l.q) : '—') + '</span></li>';
        }).join('') + '</ul>';
    });
    h += '<div class="cfgp-tot"><span>Total' + (T.off ? ' indicatif' : '') + '</span><strong>' + money(T.all) + '</strong></div>';
    if (T.off) h += '<p class="cfgp-muted">dont ' + money(T.off) + ' sur offre (hors boutique en ligne).</p>';
    return { h: h, L: L, T: T };
  }
  function renderStep5() {
    var r = renderSum(), m = M(), w = warnings(r.L);
    var h = r.h;
    if (w.length) h += '<div class="cfgp-banner is-warn">' + w.map(esc).join('<br>') + '</div>';
    var cartOk = r.L.some(function (l) { return l.shop; }) && st.prod && st.prod.v.a;
    var nCart = r.L.filter(function (l) { return l.shop; }).reduce(function (a, l) { return a + l.q; }, 0);
    var offPrim = m.offre;
    var nAll = r.L.reduce(function (a, l) { return a + l.q; }, 0);
    if (EMB) {
      h += '<div class="cfgp-actions">' +
        '<button type="button" class="btn btn--primary js-cfgp-liste"' + (st.prod && (st.kit || st.none) ? '' : ' disabled') + '>Créer une liste d’achat (' + nAll + ' article' + (nAll > 1 ? 's' : '') + ')</button>' +
        '<button type="button" class="btn btn--secondary js-cfgp-copy">Copier le récapitulatif</button>' +
        '</div>';
      if (r.L.some(function (l) { return !l.shop; })) h += '<p class="cfgp-muted">Les articles « sur offre » arrivent dans la liste en lignes à compléter, au prix catalogue Glatz TTC.</p>';
    } else {
      h += '<div class="cfgp-actions">' +
        '<button type="button" class="btn ' + (offPrim ? 'btn--secondary' : 'btn--primary') + ' js-cfgp-cart"' + (cartOk ? '' : ' disabled') + '>Ajouter toute la configuration au panier' + (nCart > 1 ? ' (' + nCart + ' articles)' : '') + '</button>' +
        '<button type="button" class="btn ' + (offPrim ? 'btn--primary' : 'btn--secondary') + ' js-cfgp-offre">Demander une offre</button>' +
        '</div>';
      if (r.L.some(function (l) { return !l.shop; })) h += '<p class="cfgp-muted">Les articles « sur offre » ne passent pas par le panier : ils sont joints à votre commande comme demande de complément, et chiffrés par nos soins.</p>';
    }
    h += '<div class="cfgp-msg-out" role="status"></div>';
    body(5).innerHTML = h;
    body(5).appendChild(formEl);
    $('.cfgp-offre-fields', formEl).hidden = !st.showOffre;
    body(5).insertAdjacentHTML('beforeend', gallery(r.L) + '<p class="cfgp-restart"><button type="button" class="cfgp-reset js-cfgp-reset">↺ Recommencer la configuration</button></p>');
  }
  function gallery(L) {
    if (!L.length) return '';
    var tc = curToile();
    return '<div class="cfgp-gal"><p class="cfgp-group">Votre sélection en images</p><div class="cfgp-gal-grid">' + L.map(function (l) {
      var tcard = l.main && tc ? '<div class="cfgp-gal-card is-toile">' +
        '<div class="cfgp-gal-img" style="background:' + tc.hex + '"><img src="' + esc(tSrc(tc, 400)) + '" alt="" loading="lazy"></div>' +
        '<p class="cfgp-gal-t">Toile ' + esc(tc.lab) + (tc.q ? ' · Qualité ' + tc.q : '') + '</p>' +
        '<p class="cfgp-gal-p"><span class="cfgp-muted">comprise avec le parasol</span></p></div>' : '';
      return '<div class="cfgp-gal-card' + (l.shop ? '' : ' is-off') + '">' +
        '<div class="cfgp-gal-img">' + (l.img ? '<img src="' + esc(l.img) + '" alt="" loading="lazy">' : '<span class="cfgp-gal-ph">' + (l.main ? ico('centre') : 'Photo à venir') + '</span>') +
        (l.q > 1 ? '<span class="cfgp-gal-q">× ' + l.q + '</span>' : '') + '</div>' +
        '<p class="cfgp-gal-t">' + esc(l.t) + '</p>' +
        '<p class="cfgp-gal-p">' + (l.p != null ? money(l.p * l.q) : '') + (l.shop ? '' : ' <span class="cfgp-onreq">sur offre</span>') + '</p></div>' + tcard;
    }).join('') + '</div></div>';
  }
  function reset() {
    st = { grp: null, sh: null, bk: -1, mk: null, prod: null, ovSel: [], key: null, kit: null, kitReq: {}, kitOpt: {}, none: false, hs: {}, acc: {}, pz: '', par: {} };
    [2, 3, 4, 5].forEach(function (n) { show(n, false); });
    $('.cfgp-side').hidden = true; $('.cfgp-bar').hidden = true;
    $('.cfgp-offre-fields', formEl).hidden = true;
    if (LOCK) { st.grp = 'all'; selectModel(LOCK); smoothTo(topOf(root)); return; } // fiche bridée : on recommence sur le même parasol
    if (!EMB) try { var u = new URL(location.href); u.searchParams.delete('modele'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { /* rien */ }
    renderStep1();
    smoothTo(topOf(root));
  }
  function refresh() {
    if (!st.prod) return;
    renderStep5();
    var side = $('.cfgp-side'); side.hidden = false;
    $('.cfgp-sum', side).innerHTML = renderSum().h + '<button type="button" class="btn btn--primary js-cfgp-tosum">Terminer</button><button type="button" class="cfgp-reset js-cfgp-reset">↺ Recommencer</button>';
    var bar = $('.cfgp-bar'); bar.hidden = false;
    var T = totals(buildLines());
    $('.cfgp-bar-t', bar).innerHTML = '<span>Total' + (T.off ? ' indicatif' : '') + '</span> <strong>' + money(T.all) + '</strong>';
  }
  function afterVariant() {
    show(3, true); show(4, true); show(5, true);
    // fixation choisie toujours admise ?
    var m = M(), mn = minKg().kg;
    if (st.kit) { var k = m.k.filter(function (x) { return x.id === st.kit; })[0]; if (!k || !okKit(k, mn)) { st.kit = null; st.kitReq = {}; st.kitOpt = {}; } }
    renderStep3(); renderStep4(); refresh();
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('.js-cfgp-tosum')) { scrollTo(5); return; }
    if (e.target.closest('.js-cfgp-reset')) { reset(); return; }
    if (e.target.closest('.js-cfgp-cart')) { addToCart(e.target.closest('.js-cfgp-cart')); return; }
    if (e.target.closest('.js-cfgp-liste')) { toListe(e.target.closest('.js-cfgp-liste')); return; }
    if (e.target.closest('.js-cfgp-copy')) { if (O.copy) O.copy(offreText()); msg('Récapitulatif copié.'); return; }
    if (e.target.closest('.js-cfgp-offre')) { st.showOffre = true; $('.cfgp-offre-fields', formEl).hidden = false; fillOffre(); $('input[name="contact[name]"]', formEl).focus(); }
  });

  /* ---------- panier ---------- */
  function msg(t, bad) { var el = $('.cfgp-msg-out'); if (el) { el.className = 'cfgp-msg-out cfgp-banner ' + (bad ? 'is-bad' : 'is-ok'); el.textContent = t; } }
  function horsText(L) {
    return L.filter(function (l) { return !l.shop; }).map(function (l) { return (l.q > 1 ? l.q + ' × ' : '') + unit(l.t) + ' (' + l.s + ')' + (l.p != null ? ' — ' + money(l.p * l.q) : ''); }).join(' ; ');
  }
  function addToCart(btn) {
    var L = buildLines(), w = warnings(L).filter(function (x) { return !/Pz200/.test(x); });
    if (w.length) { msg(w[0], true); return; }
    var items = {}, order = [];
    L.forEach(function (l) { if (!l.shop || !l.vid) return; if (!items[l.vid]) { items[l.vid] = 0; order.push(l.vid); } items[l.vid] += l.q; });
    if (!order.length) { msg('Aucun article de cette configuration n’est vendu en ligne : demandez une offre.', true); return; }
    btn.disabled = true; btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var sections = ['cart-icon-bubble'];
    if (drawer && drawer.closest('.shopify-section')) sections.push(drawer.closest('.shopify-section').id.replace('shopify-section-', ''));
    var ref = 'Configurateur ' + unit(M().n) + (st.key ? ' ' + keyLabel(st.key) : '');
    var payload = {
      items: order.map(function (id) { return { id: +id, quantity: items[id], properties: { _configurateur: ref } }; }),
      sections: sections.join(','), sections_url: location.pathname
    };
    var hors = L.filter(function (l) { return !l.shop; });
    fetch(RT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Ajout impossible'); return j; }); })
      .then(function (data) {
        if (!hors.length) return data;
        return fetch(RT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          var a = cart.attributes || {}, prev = [];
          try { prev = JSON.parse(a._cfg_hors_shopify || '[]'); } catch (e) { prev = []; }
          hors.forEach(function (l) { prev.push({ sku: l.s, t: l.t, q: l.q, ref: ref }); });
          var txt = (a['Options sur offre'] ? a['Options sur offre'] + ' | ' : '') + ref + ' : ' + horsText(L);
          return fetch(RT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Options sur offre': txt.slice(0, 2000), _cfg_hors_shopify: JSON.stringify(prev).slice(0, 4000) } }) });
        }).then(function () { return data; });
      })
      .then(function (data) {
        msg('Ajouté au panier' + (hors.length ? ' — les options « sur offre » sont notées sur votre commande.' : '.'));
        try {
          var bub = document.getElementById('cart-icon-bubble');
          if (bub && data.sections && data.sections['cart-icon-bubble']) bub.innerHTML = data.sections['cart-icon-bubble'];
          if (drawer && drawer.renderContents && data.sections) drawer.renderContents(data, true);
          else document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        } catch (e) { /* le panier reste correct même si le tiroir ne se met pas à jour */ }
      })
      .catch(function (e) { msg(String(e.message || e), true); })
      .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  }

  /* ---------- demande d'offre (formulaire de contact Shopify) ---------- */
  function fillOffre() { $('.js-cfgp-body', formEl).value = offreText(); }
  function offreText() {
    var r = renderSum(), L = r.L, T = r.T, v = st.prod.v, m = M();
    var t = 'CONFIGURATION PARASOL GLATZ\n\n';
    t += 'Parasol : ' + unit(st.prod.t + ' — ' + v.t) + ' (SKU ' + v.sku + ')\n';
    t += 'Lien : ' + (BASE || location.origin) + st.prod.u + '?variant=' + v.id + '\n';
    if (st.key && m.sz[st.key]) t += 'Poids minimum Glatz : ' + m.sz[st.key].kg + 'kg\n';
    ['Parasol', 'Fixation', 'Housse', 'Accessoires', 'Sur offre'].forEach(function (g) {
      var ls = L.filter(function (l) { return l.g === g; }); if (!ls.length) return;
      t += '\n' + g.toUpperCase() + (g === 'Sur offre' ? ' (prix catalogue Glatz TTC)' : '') + '\n';
      ls.forEach(function (l) { t += '- ' + l.q + ' × ' + unit(l.t) + ' [' + l.s + ']' + (l.tag ? ' (' + l.tag + ')' : '') + (l.p != null ? ' : ' + money(l.p * l.q) : '') + '\n'; });
    });
    t += '\nTOTAL' + (T.off ? ' INDICATIF' : '') + ' : ' + money(T.all) + (T.off ? ' (dont ' + money(T.off) + ' sur offre)' : '') + '\n';
    return t;
  }
  /* ---------- liste d'achat (formulaire interne uniquement) ---------- */
  function toListe(btn) {
    var L = buildLines(), w = warnings(L).filter(function (x) { return !/Pz200/.test(x); });
    if (w.length) { msg(w[0], true); return; }
    var tc = curToile();
    var ref = unit(M().n) + (st.key ? ' ' + keyLabel(st.key) : '') + (tc ? ' · ' + tc.lab : '');
    var payload = {
      ref: ref.slice(0, 80),
      recap: offreText().slice(0, 1800),
      lignes: L.map(function (l) {
        return l.shop && l.vid ? { vid: String(l.vid), sku: l.s, q: l.q } : { sku: l.s, t: unit(l.t).slice(0, 200), q: l.q, p: l.p == null ? null : Math.round(l.p) / 100 };
      })
    };
    btn.disabled = true; btn.classList.add('is-loading');
    Promise.resolve(O.liste ? O.liste(payload) : { ok: false, msg: 'Indisponible' })
      .then(function (r) { msg((r && r.msg) || (r && r.ok ? 'Liste créée.' : 'Erreur'), !(r && r.ok)); })
      .catch(function (e) { msg(String(e && e.message || e), true); })
      .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  }
  formEl.addEventListener('submit', function () { if (st.prod) fillOffre(); });

  /* ---------- démarrage ---------- */
  var RAW = O.data || window.CFGP_DATA;
  if (!RAW) { body(1).innerHTML = '<div class="cfgp-banner is-bad">Le configurateur n’a pas pu se charger. Rechargez la page.</div>'; return; }
  D = expand(RAW);
  (function () {
    var q = O.modele || QS.get('modele');
    if (q && D.models[q]) {
      if (!EMB && QS.get('bride') === '1') LOCK = q;
      st.grp = 'all'; renderStep1(); selectModel(q, QVID);
    }
    else renderStep1();
  })();
  } // fin start()

  window.CFGP = { v: '1.7b', mount: function (el, opts) { start(el, opts || {}); } };
  if (!window.CFGP_NOAUTO) start(document.getElementById('cfgp'));
})();
